import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  unread: 0,
  messages: [],
  target: null,
  chatItems: [],
};

const messageSlice = createSlice({
  name: 'message',
  initialState,
  reducers: {
    setMessages(state, action) {
      state.messages = action.payload;
    },
    addMessages(state, action) {
      if (!state.target) return;
      if (state.target.uid != action.payload.uid) {
        return;
      }
      state.messages = [action.payload, ...state.messages]
      // console.log(state.messages)
    },
    setTarget(state, action) {
      state.target = action.payload;
    },
    setChatItems(state, action) {
      state.chatItems = action.payload;
    },
  },
});

export const {addMessages, setMessages, setTarget, setChatItems} = messageSlice.actions;

export default messageSlice.reducer;
